export let PTZY = `

<p style="border-bottom:1px solid white">指标说明：</p>
<div class="hint_table">
    <p class="center">平台作业</p>
    <p class="left">教师总数</p><p class="right">学校教师总数</p>
    <p class="left">布置作业教师数</p><p class="right">在平台布置作业的教师总数（包含班级作业、靶向作业、分层作业）</p>
    <p class="left">布置作业教师占比</p><p class="right">布置作业教师数/教师总数</p>
    <p class="left">收集作业教师数</p><p class="right">使用扫描仪收集学生作业的教师总数</p>
    <p class="left">收集作业教师占比</p><p class="right">收集作业教师数/教师总数</p>
    <p class="left">讲解作业教师数</p><p class="right">在上课端讲解作业的教师总数（不含AI智能卡）</p>
    <p class="left">讲解作业教师占比</p><p class="right">讲解作业教师数/教师总数</p>
</div>
`;

export let AIZNK = `
<p style="border-bottom:1px solid white">指标说明：</p>
<div class="hint_table">
    <p class="center">AI智能卡</p>
    <p class="left">收集AI智能卡教师数</p><p class="right">使用扫描仪收集学生AI智能卡作业的教师总数</p>
    <p class="left">收集AI智能卡教师占比</p><p class="right">收集AI智能卡教师数/教师总数</p>
    <p class="left">讲解AI智能卡教师数</p><p class="right">在上课端讲解AI智能卡作业的教师总数</p>
    <p class="left">讲解AI智能卡教师占比</p><p class="right">讲解AI智能卡教师数/教师总数</p>
</div>
`;

export let JSMXPTZY = `
<p style="border-bottom:1px solid white">指标说明：</p>
<div class="hint_table">
    <p class="center">注：学生重复扫描只计为一份</p>
    <p class="left">布置/收集班级作业次数</p><p class="right">各教师布置/收集班级作业的次数（完成一次组卷并发布或打印算一次作业）</p>
    <p class="left">布置/收集班级作业份数</p><p class="right">各教师布置/收集到每位学生的班级作业的份数</p>
    <p class="left">布置/收集靶向作业次数</p><p class="right">各教师布置/收集靶向作业的次数（完成一次组卷并发布或打印算一次作业）</p>
    <p class="left">布置/收集靶向作业份数</p><p class="right">各教师布置/收集每位学生的靶向作业的份数</p>
    <p class="left">布置/收集分层作业次数</p><p class="right">各教师布置/收集分层作业的次数（完成一次组卷并发布或打印算一次作业）</p>
    <p class="left">布置/收集分层作业份数</p><p class="right">各教师布置/收集每位学生的分层作业的份数</p>
    <p class="left">讲解作业数</p><p class="right">各教师讲解作业的数量（不含AI智能卡）</p>
</div>
`;
export let JSMXAIZNK = `
<p style="border-bottom:1px solid white">指标说明：</p>
<div class="hint_table">
    <p class="center">注：学生重复扫描只计为一份</p>
    <p class="left">采集AI智能卡次数</p><p class="right">教师所教班级用扫描仪扫描AI智能卡的次数（一个行政班扫描一个章节计为一次）</p>
    <p class="left">采集AI智能卡份数</p><p class="right">教师所教班级采集每位学生的AI智能卡的总份数</p>
    <p class="left">讲解AI智能卡次数</p><p class="right">教师讲解AI智能卡次数（在一个行政班讲解一个章节计为一次）</p>
</div>
`;

//课件分析
export let KJFX = `
<p style="border-bottom:1px solid white">指标说明：</p>
<div class="hint_table">
    <p class="left">教师总数</p><p class="right">学校教师总数</p>
    <p class="left">上传课件教师数</p><p class="right">在备课端上传课件的教师总数</p>
    <p class="left">上传课件教师占比</p><p class="right">上传课件教师数/教师总数</p>
    <p class="left">人均上传课件数</p><p class="right">学校上传课件总数/上传课件教师数</p>
    <p class="left">使用课件备课教师数</p><p class="right">在备课端点开课件的教师总数</p>
    <p class="left">使用课件备课教师占比</p><p class="right">使用课件备课教师数/教师总数</p>
    <p class="left">人均备课使用课件数</p><p class="right">学校每位教师在备课端打开的课件数之和/使用课件备课教师数</p>
    <p class="left">使用课件授课教师数</p><p class="right">在上课端打开课件的教师数</p>
    <p class="left">使用课件授课教师占比</p><p class="right">使用课件授课教师数/教师总数</p>
    <p class="left">人均授课使用课件数</p><p class="right">学校每位教师在备课端打开的课件数之和/使用课件授课教师数</p>
</div>
`;

export let JSMXKJFX = `
<p style="border-bottom:1px solid white">指标说明：</p>
<div class="hint_table">
    <p class="left">上传课件数</p><p class="right">在备课端上传的课件总数</p>
    <p class="left">备课使用课件数</p><p class="right">教师在备课端打开的课件总数（去重）</p>
    <p class="left">授课使用课件数</p><p class="right">教师在上课端打开的课件总数（去重）</p>
</div>
`;

//学校活跃
export let XXTJ = `
<p style="border-bottom:1px solid white">指标说明：</p>
<div class="hint_table">
    <p class="left">教师总数</p><p class="right">学校教师总数（不包含教务端设置为不参与统计的教师）</p>
    <p class="left">登录教师数</p><p class="right">在平台登录的教师数（包含网页、优师端）</p>
    <p class="left">教师登录率</p><p class="right">登录教师数/教师总数</p>
    <p class="left">活跃教师数</p><p class="right">在平台有有效操作的教师数（有效操作详见教师明细中的二级分类项）</p>
    <p class="left">教师活跃率</p><p class="right">活跃教师数/教师总数</p>
    <p class="left">功能使用度</p><p class="right">教师各有效操作的使用总次数</p>
    <p class="left">备课</p><p class="right">教师备课相关功能的使用次数</p>
    <p class="left">上课</p><p class="right">教师上课端相关功能的使用次数</p>
    <p class="left">作业</p><p class="right">教师作业功能的使用次数</p>
    <p class="left">智能卡</p><p class="right">教师智能卡功能的使用次数</p>
</div>
`;

// 学校教师明细一级分类
export let XXJSYJFL = `
<p style="border-bottom:1px solid white">指标说明：</p>
<div class="hint_table">
    <p class="left">是否登录</p><p class="right">教师在周期内是否登录过平台（网页端、app登录均计为登录）</p>
    <p class="left">功能使用度</p><p class="right">教师各有效操作的使用总次数</p>
    <p class="left">备课</p><p class="right">教师备课相关功能的使用次数</p>
    <p class="left">上课</p><p class="right">教师上课端相关功能的使用次数</p>
    <p class="left">作业</p><p class="right">教师作业功能的使用次数</p>
    <p class="left">智能卡</p><p class="right">教师智能卡功能的使用次数</p>
</div>
`;

// 学校教师明细二级分类
export let XXJSEJFL = `
<p style="border-bottom:1px solid white">指标说明：</p>
<div class="hint_table">
    <p class="center">注：统计指标包含网页端和优师端都有的功能点的操作总和</p>
    <p class="left">是否登录</p><p class="right">教师在周期内是否登录过平台（网页端、app登录均计为登录）</p>
    <p class="left">功能使用度</p><p class="right">教师各有效操作的使用总次数</p>
    <p class="left">课程模块</p><p class="right">教师备课端课程模块的功能的使用次数（包含优师端查看课程主线、管理课程、查看课程等）</p>
    <p class="left">班级管理</p><p class="right">教师备课端使用的班级管理相关功能的次数（包含导入班级、设置分层、设置随机点名范围、创建学习小组等）</p>
    <p class="left">备课-查看课件</p><p class="right">教师在备课端查看课件的使用次数</p>
    <p class="left">上传课件</p><p class="right">教师上传的课件数（包含直接上传和在线创建）</p>
    <p class="left">分享课件</p><p class="right">教师分享课件次数（给同一群体重复分享只记为一次）</p>
    <p class="left">精彩瞬间</p><p class="right">教师使用精彩瞬间功能的次数</p>
    <p class="left">上课-工具模块</p><p class="right">教师在上课端使用各教学工具的次数（包含画板、同步投影、计时器、随机点名、使用课件和其他工具使用等）</p>
    <p class="left">布置作业选题模块</p><p class="right">教师布置作业时从各题目来源选题的次数</p>
    <p class="left">知识点</p><p class="right">教师查看知识点掌握值的次数</p>
    <p class="left">作业-查看成绩</p><p class="right">教师在备课端查看学生作业成绩的次数</p>
    <p class="left">布置/收集作业</p><p class="right">教师在平台布置/收集班级作业的次数（完成一次组卷并发布或打印算一次作业）</p>
    <p class="left">批改作业</p><p class="right">教师批改作业的次数（完成一次组卷并发布或打印算一次作业）</p>
    <p class="left">讲解作业</p><p class="right">教师在上课端讲解作业的次数（给一个教学班讲解一个作业算一次）</p>
    <p class="left">收集智能卡</p><p class="right">教师收集智能卡作业的章节数量（去重）</p>
    <p class="left">批改智能卡</p><p class="right">教师批改智能卡作业的章节数量（去重）</p>
    <p class="left">智能卡-查看智能卡</p><p class="right">教师在备课端查看智能卡内容的次数</p>
    <p class="left">讲解智能卡</p><p class="right">教师在上课端讲解智能卡的次数（给一个教学班讲解一个章节算一次）</p>
</div>
`;

// 年级活跃
export let NJHY = `
<p style="border-bottom:1px solid white">指标说明：</p>
<div class="hint_table">
    <p class="center">注：年级通过教师教学行为对象的班级或课程中加入的行政班的年级来判断</p>
    <p class="left">教师总数</p><p class="right">学校对应年级的教师总数（不包含教务端设置为不参与统计的教师；年级为教师课程中加入的行政班年级）</p>
    <p class="left">活跃教师数</p><p class="right">对应年级的教师中在平台有有效操作的教师数（有效操作详见教师明细中的二级分类项）</p>
    <p class="left">教师活跃率</p><p class="right">活跃教师数/教师总数</p>
    <p class="left">功能使用度</p><p class="right">教师各有效操作的使用总次数</p>
    <p class="left">备课</p><p class="right">教师备课相关功能的使用次数</p>
    <p class="left">上课</p><p class="right">教师上课端相关功能的使用次数</p>
    <p class="left">作业</p><p class="right">教师作业功能的使用次数</p>
    <p class="left">智能卡</p><p class="right">教师智能卡功能的使用次数</p>
</div>
`;

// 学科活跃
export let XKHY = `
<p style="border-bottom:1px solid white">指标说明：</p>
<div class="hint_table">
    <p class="center">注：学科通过教师教学行为对象的课程的学科属性来判断</p>
    <p class="left">教师总数</p><p class="right">学校对应学科的教师总数（不包含教务端设置为不参与统计的教师；学科为教师加入的课程的所属学科）</p>
    <p class="left">活跃教师数</p><p class="right">对应学科的教师中在平台有有效操作的教师数（有效操作详见教师明细中的二级分类项）</p>
    <p class="left">教师活跃率</p><p class="right">活跃教师数/教师总数</p>
    <p class="left">功能使用度</p><p class="right">教师各有效操作的使用总次数</p>
    <p class="left">备课</p><p class="right">教师备课相关功能的使用次数</p>
    <p class="left">上课</p><p class="right">教师上课端相关功能的使用次数</p>
    <p class="left">作业</p><p class="right">教师作业功能的使用次数</p>
    <p class="left">智能卡</p><p class="right">教师智能卡功能的使用次数</p>
</div>
`;


// 年级学科活跃一级分类
export let NJXKYJFL = `
<p style="border-bottom:1px solid white">指标说明：</p>
<div class="hint_table">
    <p class="left">功能使用度</p><p class="right">教师各有效操作的使用总次数</p>
    <p class="left">备课</p><p class="right">教师备课相关功能的使用次数</p>
    <p class="left">上课</p><p class="right">教师上课端相关功能的使用次数</p>
    <p class="left">作业</p><p class="right">教师作业功能的使用次数</p>
    <p class="left">智能卡</p><p class="right">教师智能卡功能的使用次数</p>
</div>
`;

// 年级学科活跃二级分类
export let NJXKEJFL = `
<p style="border-bottom:1px solid white">指标说明：</p>
<div class="hint_table">
    <p class="center">注：统计指标包含网页端和优师端都有的功能点的操作总和</p>
    <p class="left">课程模块</p><p class="right">教师备课端课程模块的功能的使用次数（包含优师端查看课程主线、管理课程、查看课程等）</p>
    <p class="left">备课-查看课件</p><p class="right">教师在备课端查看课件的使用次数</p>
    <p class="left">上传课件</p><p class="right">教师上传的课件数（包含直接上传和在线创建）</p>
    <p class="left">分享课件</p><p class="right">教师分享课件次数（给同一群体重复分享只记为一次）</p>
    <p class="left">精彩瞬间</p><p class="right">教师使用精彩瞬间功能的次数</p>
    <p class="left">上课-工具模块</p><p class="right">教师在上课端使用各教学工具的次数（包含画板、同步投影、计时器、随机点名、使用课件和其他工具使用等）</p>
    <p class="left">布置作业选题模块</p><p class="right">教师布置作业时从各题目来源选题的次数</p>
    <p class="left">知识点</p><p class="right">教师查看知识点掌握值的次数</p>
    <p class="left">作业-查看成绩</p><p class="right">教师在备课端查看学生作业成绩的次数</p>
    <p class="left">布置/收集作业</p><p class="right">教师在平台布置/收集班级作业的次数（完成一次组卷并发布或打印算一次作业）</p>
    <p class="left">批改作业</p><p class="right">教师批改作业的次数（完成一次组卷并发布或打印算一次作业）</p>
    <p class="left">讲解作业</p><p class="right">教师在上课端讲解作业的次数（给一个教学班讲解一个作业算一次）</p>
    <p class="left">收集智能卡</p><p class="right">教师收集智能卡作业的章节数量（去重）</p>
    <p class="left">批改智能卡</p><p class="right">教师批改智能卡作业的章节数量（去重）</p>
    <p class="left">智能卡-查看智能卡</p><p class="right">教师在备课端查看智能卡内容的次数</p>
    <p class="left">讲解智能卡</p><p class="right">教师在上课端讲解智能卡的次数（给一个教学班讲解一个章节算一次）</p>
</div>
`;

// 区域题库分析
export let QYTKFX = `
<p style="border-bottom:1px solid white">指标说明：</p>
<div class="hint_table">
    <p class="left">区</p><p class="right">题库授权学校所属区</p>
    <p class="left">年级</p><p class="right">题库所属年级</p>
    <p class="left">学科</p><p class="right">题库所属学科</p>
    <p class="left">录入题目数量</p><p class="right">题库录入的题目总数（按大题计算）</p>
    <p class="left">使用题数</p><p class="right">题库中被使用过的题数（组卷并发布）</p>
    <p class="left">使用题次</p><p class="right">题库中的题目被使用的总次数</p>
    <p class="left">每题平均使用次数</p><p class="right">使用题次/使用题数</p>
    <p class="left">使用教师数</p><p class="right">使用题库中题进行组卷发布作业的教师数</p>
    <p class="left">教师人均使用题数</p><p class="right">每位教师使用的题数之和/使用教师数</p>
    <p class="left">组卷数</p><p class="right">使用题库中的题完成组卷的作业总数</p>
</div>
`;


